import React, { Component } from 'react';
import PropTypes from 'prop-types';

import cardStyles from 'assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.jsx';
import { Typography, withStyles } from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import MediaQuery from 'react-responsive';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import { cardTitle } from 'assets/jss/material-kit-pro-react.jsx';

const styles = () => ({
    ...cardStyles,
    headerSearch: {
        width: '100%',
        margin: 0,
    },
    cardSearchBar: {
        marginBottom: 0,
        marginTop: 0,
        borderRadius: 0,
    },
    cardTitle: {
        ...cardTitle,
        color: '#000000 !important',
    },
    media: {
        "@media screen and (max-width: 1200px)":
            {
                display: 'none',
            }
    },

    header: {
        "@media screen and (max-width: 900px)":
            {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                '& div': {
                    maxWidth: 'none',
                    textAlign: 'center',
                }
            },
                
    }
});

class EntityExtractionDetails extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { classes, details } = this.props;

        return (
            <div className={classes.headerSearch}>
                <div className={classes.headerContainer}>
                    <GridContainer>
                        <GridItem
                            xs={12}
                            sm={12}
                            md={12}
                            className={`${classes.mlAuto} ${classes.mrAuto}`}
                        >
                            <Card className={classes.cardSearchBar}>
                                <CardBody formHorizontal>
                                    <form>
                                        <GridContainer className={classes.header}>
                                            {/* Candid title */}
                                            <GridItem xs={12} sm={2} md={2} className={`${classes.media}`}>
                                                {/* <MediaQuery minDeviceWidth={1224}> */}
                                                <MediaQuery minWidth={1200}>
                                                    <div className="news-title">Social Sector News</div>
                                                    <div className="candid-subtitle">
                                                        powered by <span className="name">Candid.</span>
                                                    </div>
                                                </MediaQuery>
                                            </GridItem>
                                            <MediaQuery minWidth={1201}>
                                                <GridItem xs={12} sm={3} md={3}>
                                                    {details.title &&
                                                        <div className={classes.cardTitle}>
                                                            <h4>
                                                                <b>{details.title}</b>
                                                            </h4>
                                                        </div>
                                                    }
                                                </GridItem>
                                            </MediaQuery>
                                            <MediaQuery maxWidth={1200}>
                                                <GridItem xs={12} sm={5} md={5}>
                                                    {details.title &&
                                                        <div className={classes.cardTitle}>
                                                            <h4>
                                                                <b>{details.title}</b>
                                                            </h4>
                                                        </div>
                                                    }
                                                </GridItem>
                                            </MediaQuery>
                                            <GridItem xs={12} sm={2} md={2}>
                                                {details.site_name &&
                                                    <Typography
                                                        variant="caption"
                                                        gutterBottom
                                                        noWrap
                                                        color="textSecondary"
                                                    >
                                                        {details.site_name}
                                                    </Typography>
                                                }
                                                {details.event_date &&
                                                    <Typography
                                                        variant="caption"
                                                        gutterBottom
                                                        noWrap
                                                        color="textSecondary"
                                                    >
                                                        {details.event_date}
                                                    </Typography>
                                                }
                                                {details.data_id &&
                                                    <Typography
                                                        variant="caption"
                                                        gutterBottom
                                                        noWrap
                                                        color="textSecondary"
                                                    >
                                                        {details.data_id}
                                                    </Typography>
                                                }
                                                {details.is_grant &&
                                                    <Typography
                                                        variant="caption"
                                                        gutterBottom
                                                        noWrap
                                                        color="textSecondary"
                                                    >
                                                        {details.is_grant}
                                                    </Typography>
                                                }
                                            </GridItem>

                                            <GridItem xs={12} sm={2} md={2}>
                                                {details.has_rfp &&
                                                    <Typography
                                                        variant="caption"
                                                        gutterBottom
                                                        noWrap
                                                        color="textSecondary"
                                                    >
                                                        {details.has_rfp}
                                                    </Typography>
                                                }
                                                {details.is_advisory_confidence &&
                                                    <Typography
                                                        variant="caption"
                                                        gutterBottom
                                                        noWrap
                                                        color="textSecondary"
                                                    >
                                                        {details.is_advisory_confidence}
                                                    </Typography>
                                                }

                                                {details.is_grant_confidence &&
                                                    <Typography
                                                        variant="caption"
                                                        gutterBottom
                                                        noWrap
                                                        color="textSecondary"
                                                    >
                                                        {details.is_grant_confidence}
                                                    </Typography>
                                                }

                                                {details.is_important_confidence &&
                                                    <Typography
                                                        variant="caption"
                                                        gutterBottom
                                                        noWrap
                                                        color="textSecondary"
                                                    >
                                                        {details.is_important_confidence}
                                                    </Typography>
                                                }
                                            </GridItem>

                                            <GridItem xs={12} sm={2} md={2}>
                                                {details.is_rfp_confidence &&
                                                    <Typography
                                                        variant="caption"
                                                        gutterBottom
                                                        noWrap
                                                        color="textSecondary"
                                                    >
                                                        {details.is_rfp_confidence}
                                                    </Typography>
                                                }

                                                {details.is_sector_relevant_confidence &&
                                                    <Typography
                                                        variant="caption"
                                                        gutterBottom
                                                        noWrap
                                                        color="textSecondary"
                                                    >
                                                        {details.is_sector_relevant_confidence}
                                                    </Typography>
                                                }

                                                {details.is_staff_change_confidence &&
                                                    <Typography
                                                        variant="caption"
                                                        gutterBottom
                                                        noWrap
                                                        color="textSecondary"
                                                    >
                                                        {details.is_staff_change_confidence}
                                                    </Typography>
                                                }

                                                {details.is_trustworthy_confidence && 
                                                    <Typography
                                                        variant="caption"
                                                        gutterBottom
                                                        noWrap
                                                        color="textSecondary"
                                                    >
                                                        {details.is_trustworthy_confidence}
                                                    </Typography>
                                                }
                                            </GridItem>
                                        </GridContainer>
                                    </form>
                                </CardBody>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </div>
            </div>
        );
    }
}

EntityExtractionDetails.propTypes = {
    classes: PropTypes.object,
    details: PropTypes.object,
};

const styledComponent = withStyles(styles)(EntityExtractionDetails);
export default styledComponent;



// WEBPACK FOOTER //
// ./src/components/EntityExtractionDetails/EntityExtractionDetails.jsx